import { useEffect, useRef, useState } from 'react'

/**
 * Bir değeri debounce eder — arama input'larında queryKey'e beslenecek
 * gecikmeli değeri üretir. Query her tuşta değil, kullanıcı yazmayı
 * bıraktıktan `delay` ms sonra bir kez tetiklenir.
 *
 * Düşük donanımlı makinelerde arama kasmasının kök nedeni, ham
 * `onChange -> setSearch -> queryKey` zincirinin her tuşta bir HTTP
 * isteği + tam yeniden render tetiklemesidir. Bu hook input'un anlık
 * tepkiselliğini bozmadan (kutu her tuşu gösterir) sadece query'yi geciktirir.
 *
 * @param {*} value - anlık değer (ör. arama metni)
 * @param {number} delay - ms cinsinden gecikme (varsayılan 350)
 * @returns debounce'lanmış değer
 */
export function useDebouncedValue(value, delay = 350) {
  const [debounced, setDebounced] = useState(value)
  const timeoutRef = useRef(null)

  useEffect(() => {
    timeoutRef.current = setTimeout(() => setDebounced(value), delay)
    // Değer/gecikme değişiminde ve unmount'ta bekleyen timer temizlenir
    // (asılı kalan timer / memory leak koruması).
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [value, delay])

  return debounced
}

export default useDebouncedValue
